// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import VueI18n from 'vue-i18n';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueImg from 'v-img/lib';
import VeeValidate, { Validator } from 'vee-validate';
import zhTW from 'vee-validate/dist/locale/zh_TW';

import skygear from 'skygear';

import App from './App';
import router from './router';
import messages from './locale';


Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);
Vue.use(VueImg);

Validator.localize('zh_TW', zhTW);
Validator.updateDictionary({
  zh_TW: messages['zh-hk'].validator,
});
Vue.use(VeeValidate, {
  locale: 'zh_TW',
});

skygear.config({
  endPoint: process.env.SKYGEAR_ENDPOINT,
  apiKey: process.env.SKYGEAR_APIKEY,
});

const i18n = new VueI18n({
  locale: 'zh-hk',
  messages,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js